import * as types from './mutation-types';
import cache, {keys} from '../services/cache';
import bus from '../services/bus-event';
import { Thread } from '@movilizame/networking';
// import broadcaster from '@/cordova/broadcaster';

export const init = (store, runningFromCordova) => {
    console.log('starting application');

    let promises = [];
    let loadStateMap = [
        {
            key: keys.TOKEN_KEY,
            mutation: 'auth/' + types.AUTH_SET_TOKEN
        },
        {
            key: keys.USER_KEY,
            mutation: 'auth/' + types.AUTH_SET_USER
        },
        {
            key: keys.COMPANY_KEY,
            mutation: 'company/SET_CONFIG'
        }
    ];

    loadStateMap.forEach(obj => {
        let p = new Promise((resolve, reject) => {
            cache.getItem(obj.key).then((value) => {
                store.commit(obj.mutation, value);
                resolve();
            }).catch(() => {
                resolve();
            });
        });
        promises.push(p);
    });

    if (runningFromCordova) {
        let p = new Promise((resolve, reject) => {
            bus.on('device-register', resolve);
            setTimeout(() => {
                bus.emit('device-register');
            }, 4000);
        });
        promises.push(p);

        bus.on('device-updated', function () {
            store.dispatch('auth/updateDevice', true, { root: true }).then(() => {
                console.log('auth/updateDevice success');
            });
        });
    }

    return Promise.all(promises).then((result) => {
        if (result.status === 'rejected') {
            console.log('catch all', result);
        } else {
            if (store.state.auth.token) {
                store.dispatch('auth/retoken').then(() => startApp(store));
            } else {
                startApp(store);
            }
        }
    }).finally((e) => {
        startApp(store);
    });
};

export const startApp = (store) => {
    cache.setItem('app_package_name', process.env.TARGET_APP);
    cache.setItem('app_bundle_name', process.env.APP_BUNDLE);
    if (store.state.auth.auth) {
        store.dispatch('startThread');
        if (store.getters['auth/isChofer']) {
            store.dispatch('geolocation/init', 'background');
        } else {
            store.dispatch('geolocation/init', 'foreground');
        }
        store.dispatch('auth/enableBackgroundActivities', store.state.auth.user);
    }
    store.dispatch('device/resize');
    store.dispatch('device/checkIntenertConnection');
    store.dispatch('company/getConfig');
    bus.emit('system-ready');
};

export const startThread = (store) => {
    // let t = new Thread({ interval: 5 * 60 * 1000, runImmediately: true });
    // t.action(({next}) => { broadcaster(); next(); }).tag('hearbeat').run();
};

export const stopThread = (store) => {
    Thread.stopThreads('hearbeat');
};



// WEBPACK FOOTER //
// ./src/store/actions.js